export function GenericHttpsIcon() {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 373.71 200"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M326 0H47.73L0 100l47.73 100H326l47.73-100Zm-15.95 183.36H58.22L18.43 100l39.79-83.36h251.83L349.84 100Z"
        fill="#008ec7"
      />
      <path
        d="m349.84 100.01-39.79 83.36H58.22l-39.79-83.36 39.79-83.37h251.83l39.79 83.37z"
        fill="#005b9b"
      />
      <path
        d="M128.05 71.89v59.53h-13.78V107h-27v24.41H73.46V71.89h13.77v23.47h27V71.89ZM154.5 83.12h-19.05V71.89h51.87v11.23h-19v48.3H154.5ZM207.9 83.12h-19.05V71.89h51.87v11.23h-19.05v48.3H207.9ZM287.62 74.53a20.45 20.45 0 0 1 9 7.48 20.67 20.67 0 0 1 3.14 11.48 20.73 20.73 0 0 1-3.14 11.44 20.06 20.06 0 0 1-9 7.48 33.55 33.55 0 0 1-13.74 2.59h-12v16.42h-13.76V71.89h25.76a33.05 33.05 0 0 1 13.74 2.64Zm-5.06 26.57a9.33 9.33 0 0 0 3.23-7.61c0-3.34-1.08-5.91-3.23-7.69s-5.3-2.68-9.44-2.68h-11.23v20.66h11.23q6.21 0 9.44-2.68Z"
        fill="#fff"
      />
    </svg>
  );
}
